<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="content flex" [@slide]="(sideNavVisible$ | async) ? 'close' : 'open'">
</div>
